export const paymentMethod = [
  {
    id: 1,
    value: "Cash on Delivery",
  },
  {
    id: 2,
    value: "Online",
  },
];

export function formatDate(string) {
  var options = { year: "numeric", month: "long", day: "numeric" };
  return new Date(string).toLocaleDateString([], options);
}
